import { cn } from "@/lib/utils";
import { SrIcon } from "@/components/ui/SrIcon";
import type { MyTask } from "@/hooks/use-my-tasks";

const PHASE_LABELS: Record<string, string> = {
  preprod: "Preproduksjon",
  production: "Produksjon",
  postprod: "Postproduksjon",
  reise: "Reise",
};

/**
 * Ett kundeprosjekt sin gruppe (prosjektnavn + oppgaver) i «Ny
 * registrering»-oppgavevelgeren. Utskilt fra NewRegistrationPopup for å
 * holde filen under filstørrelsesgrensen (endringssjekk-notat, VIB-1208).
 */
export function TaskGroupSection({
  projectName,
  tasks,
  activeIdx,
  startIdx,
  onSelectTask,
  onHoverIdx,
}: {
  projectName: string;
  tasks: MyTask[];
  activeIdx: number;
  startIdx: number;
  onSelectTask: (task: MyTask) => void;
  onHoverIdx: (idx: number) => void;
}) {
  return (
    <div>
      <p className="text-[10px] font-medium text-muted-foreground uppercase tracking-wider px-3 xl:px-4 pt-2.5 pb-1">
        {projectName}
      </p>
      {tasks.map((t, i) => {
        const itemIdx = startIdx + i;
        const isActive = itemIdx === activeIdx;
        return (
          <button
            key={t.id}
            data-idx={itemIdx}
            onClick={() => onSelectTask(t)}
            onMouseEnter={() => onHoverIdx(itemIdx)}
            className={cn(
              "w-full flex items-center gap-2 px-3 xl:px-4 py-2 text-left transition-colors group",
              isActive ? "bg-muted" : "hover:bg-muted/50",
            )}
          >
            <div className="flex-1 min-w-0">
              <p className="text-xs font-medium truncate">{t.task_description}</p>
              <p className="text-[10px] text-muted-foreground">{PHASE_LABELS[t.phase] ?? t.phase}</p>
            </div>
            <SrIcon
              name="chevron-right"
              className={cn(
                "w-3.5 h-3.5 text-muted-foreground flex-shrink-0 transition-opacity",
                isActive ? "opacity-100" : "opacity-0 group-hover:opacity-100 group-focus-visible:opacity-100",
              )}
            />
          </button>
        );
      })}
    </div>
  );
}
